import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import BootstrapVue from 'bootstrap-vue/dist/bootstrap-vue.esm';
import axios from 'axios';
import device from "vue-device-detector"

axios.defaults.baseURL = 'https://us-central1-mpt-api.cloudfunctions.net'

Vue.use(device)

Vue.config.productionTip = false
Vue.use(BootstrapVue);

import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap-vue/dist/bootstrap-vue.css';
import 'bootstrap/dist/js/bootstrap.min.js'; //navbar 

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
